export const StorageKeysEnum = {
  ACCESS_TOKEN : 'ACCESS_TOKEN',
  ACCESS_TOKEN_WSO : 'ACCESS_TOKEN_WSO',
  REFRESH_TOKEN : 'REFRESH_TOKEN',
  USER_INFO : 'USER_INFO',
  SIT_USUARIO : 'SIT_USUARIO',
  COORDS : 'COORDS',
  IP : 'IP',
  CONTRACTS_INFORMATION : 'CONTRACTS_INFORMATION',
  PUBLIC_KEY : "PUBLIC_KEY",
  PRIVATE_KEY : "PRIVATE_KEY",
  JWT_WSO_DECODE : "JWT_WSO_DECODE",
  WELCOME : "WELCOME",
  TOKEN_FEEDBACK : "TOKEN_FEEDBACK",
  CURRENT_LANGUAGE : "CURRENT_LANGUAGE",
  MODAL_DISPLAYED : "MODAL_DISPLAYED",
  PERMISSIONS : "PERMISSIONS",
  CONTRACTS_FACMAN : "CONTRACTS_FACMAN"
}
